import { Link, useNavigate } from "react-router-dom";
import "../../CSS/menu.css";
import { useEffect, useRef, useState } from "react";

export default function MonsterMenu(){
  const detRef = useRef();
  const [menuClose, setMC] = useState("closed");
  const nav = useNavigate();

  useEffect(() => {
    window.addEventListener('pointerdown', e => handleClick(e))
    window.addEventListener('scroll', e => {if(menuClose == "open") setMC("closed")})
    return () => {
      window.removeEventListener('pointerdown', e => handleClick(e))
      window.removeEventListener('scroll', e => {if(menuClose == "open") setMC("closed")})
    }

  }, [])

  function handleClick(e){
    if (e.target.className === "monsterMenuButton") {
      setTimeout(() => setMC("closed"), 500);
    }
    else if (e.target.id !== "monsterMenu") setMC("closed")
  }

  function toggle(e){
    e.stopPropagation();
    if (e.target.tagName !== 'LI') setMC(menuClose === "open" ? "closed" : "open");
  }

  function scrollTo(id){
    // if (path.pathname === "/" || path.pathname === "")
      nav(`/#home`)
      const home = document.querySelector('#home')
      if(home) home.scrollIntoView();
      // setTimeout(() => document.querySelector(`#home`).scrollIntoView(), 50)
  }

  return <>
    <button ref={detRef} id="monsterMenu" onClick={e => toggle(e)}>&equiv;
      <ul className={menuClose}>
        <Link to ="/"          ><li className="monsterMenuButton" onClick={e=> scrollTo("bg")}>Web Design</li></Link>
        {/* <Link to ="/#gallery"     ><li className="monsterMenuButton" onClick={e=> scrollTo("gallery")}>Gallery</li></Link> */}
        <Link to ="/portfolio"    ><li className="monsterMenuButton">James's Portfolio</li></Link>
        <Link to ="/game"    ><li className="monsterMenuButton">Game</li></Link>
      </ul>
    </button>
  </>
}